// Constants for account sagas

export const REDIRECT_PATH = {
  profile: '/',
  auth: '/auth',
  onboarding: 'onboarding/persona',
  search: '/search',
  campaigns: '/campaigns',
  home: '/home',
  login: '/auth/login',
  verifyEmail: (email: string): string => `/auth/verify?email=${email}`,
  verifyPhone: (phone: string): string => `/auth/verify?phone=${phone}`,
};
